
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'portals-platform-reference-fe',
  currentProjectVersion: 'static-1.1112',
  depVersions: {
  "portals-platform-reference-fe": "static-1.1112",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.472",
  "foundations-assets": "static-1.4910",
  "foundations-theming": "static-1.4460",
  "foundations-theming-base": "static-1.3445",
  "foundations-theming-specialty": "static-1.2176",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8056",
  "hub-http-shared-msw-handlers": "static-1.10064",
  "hubspot-dlb": "static-2.1854",
  "react-dlb": "static-1.79",
  "data-fetching-client": "static-1.9707",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8011",
  "hub-http": "static-1.6263",
  "HubStyleTokens": "static-2.11514",
  "I18n": "static-7.1633",
  "js-cookie": "static-1.18",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.977",
  "quartz-config": "static-1.860",
  "quartz-core": "static-1.6301",
  "quartz-routing": "static-1.512",
  "quick-fetch": "static-1.3949",
  "react": "static-7.186",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-fix-in-app-reporter-stuck-start-timestamp.5",
  "rpc-client-utils": "static-1.4693",
  "ui-addon-react-router-dom": "static-1.9583",
  "UIComponents": "static-3.8460",
  "usage-tracker": "static-1.7391",
  "usage-tracker-anonymous": "static-1.5808",
  "usage-tracker-core": "static-1.7241",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3430",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3359",
  "quartz-webpack": "static-1.3306",
  "bend-plugin-quartz-routing": "static-1.160",
  "webpack-env": "static-1.54",
  "bend-plugin-foundations-theming": "static-1.2943",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9464",
  "react-utils": "static-2.5375",
  "StyleGuideUI": "static-3.488",
  "stylex": "static-1.33",
  "HeadJS": "static-2.765",
  "quartz": "static-1.7082",
  "hs-test-utils-bend-plugin": "static-1.3167",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "ts-schema": "static-1.4112",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "bend-plugin-foundations-components": "static-1.4280",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.31",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2050",
  "ui-fonts": "static-1.776",
  "ui-images": "static-2.1163",
  "hs-locale-management": "static-1.112",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.83",
  "interframe": "static-3.4800",
  "usage-tracker-multi": "static-1.5805",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4683",
  "icons": "static-2.650",
  "jasmine": "static-4.4367",
  "jasmine-runner": "static-1.6504",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.757",
  "quartz-head": "static-1.747",
  "quartz-i18n": "static-1.757",
  "quartz-test": "static-1.757",
  "quartz-tracking": "static-1.461",
  "usage-tracker-container": "static-1.7381",
  "csstype": "static-1.50",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.103",
  "chirp-fetch": "static-1.1929",
  "cssUtils": "static-1.801",
  "HubStyle": "static-2.11821",
  "bender-build-tools": "static-1.3227",
  "react-input-autosize": "static-2.17",
  "usage-tracker-public": "static-1.7202",
  "sassPrefix": "static-1.156",
  "hubspotter-http-shared-msw-handlers": "static-1.10062",
  "usage-tracker-session-replay": "static-1.5077",
  "amplitude-session-replay-browser": "static-1.61"
},
  depPathPrefixes: {
  "portals-platform-reference-fe": "/portals-platform-reference-fe/static-1.1112",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.472",
  "foundations-assets": "/foundations-assets/static-1.4910",
  "foundations-theming": "/foundations-theming/static-1.4460",
  "foundations-theming-base": "/foundations-theming-base/static-1.3445",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2176",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8056",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10064",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "react-dlb": "/react-dlb/static-1.79",
  "data-fetching-client": "/data-fetching-client/static-1.9707",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8011",
  "hub-http": "/hub-http/static-1.6263",
  "HubStyleTokens": "/HubStyleTokens/static-2.11514",
  "I18n": "/I18n/static-7.1633",
  "js-cookie": "/js-cookie/static-1.18",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.977",
  "quartz-config": "/quartz-config/static-1.860",
  "quartz-core": "/quartz-core/static-1.6301",
  "quartz-routing": "/quartz-routing/static-1.512",
  "quick-fetch": "/quick-fetch/static-1.3949",
  "react": "/react/static-7.186",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-fix-in-app-reporter-stuck-start-timestamp.5",
  "rpc-client-utils": "/rpc-client-utils/static-1.4693",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9583",
  "UIComponents": "/UIComponents/static-3.8460",
  "usage-tracker": "/usage-tracker/static-1.7391",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5808",
  "usage-tracker-core": "/usage-tracker-core/static-1.7241",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3430",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3359",
  "quartz-webpack": "/quartz-webpack/static-1.3306",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.160",
  "webpack-env": "/webpack-env/static-1.54",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2943",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9464",
  "react-utils": "/react-utils/static-2.5375",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.765",
  "quartz": "/quartz/static-1.7082",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3167",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "ts-schema": "/ts-schema/static-1.4112",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4280",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2050",
  "ui-fonts": "/ui-fonts/static-1.776",
  "ui-images": "/ui-images/static-2.1163",
  "hs-locale-management": "/hs-locale-management/static-1.112",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.83",
  "interframe": "/interframe/static-3.4800",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5805",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4683",
  "icons": "/icons/static-2.650",
  "jasmine": "/jasmine/static-4.4367",
  "jasmine-runner": "/jasmine-runner/static-1.6504",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.757",
  "quartz-head": "/quartz-head/static-1.747",
  "quartz-i18n": "/quartz-i18n/static-1.757",
  "quartz-test": "/quartz-test/static-1.757",
  "quartz-tracking": "/quartz-tracking/static-1.461",
  "usage-tracker-container": "/usage-tracker-container/static-1.7381",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.103",
  "chirp-fetch": "/chirp-fetch/static-1.1929",
  "cssUtils": "/cssUtils/static-1.801",
  "HubStyle": "/HubStyle/static-2.11821",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "usage-tracker-public": "/usage-tracker-public/static-1.7202",
  "sassPrefix": "/sassPrefix/static-1.156",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10062",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5077",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.61"
}
};
